import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-item-not-found',
  templateUrl: './item-not-found.component.html',
  styleUrls: ['./item-not-found.component.scss']
})
export class ItemNotFoundComponent {
  @Input() description: string | undefined;
  @Input() goBackToLink: string | undefined;

  constructor(private router: Router) {}
  navigateBack() {
    this.router.navigate([this.goBackToLink]);
  }
}
